/**
 * @generated SignedSource<<487fdc5849d48ce6d335ff4336ea7410>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useShowVimeoVideo_viewer$data = {
  readonly videoUploadToolsFeatureFlag: boolean | null;
  readonly " $fragmentType": "useShowVimeoVideo_viewer";
};
export type useShowVimeoVideo_viewer$key = {
  readonly " $data"?: useShowVimeoVideo_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"useShowVimeoVideo_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useShowVimeoVideo_viewer",
  "selections": [
    {
      "alias": "videoUploadToolsFeatureFlag",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "videoUploadTools"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"videoUploadTools\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "7e705d1183aa1cd1360bdc558e68de92";

export default node;
